




import { Component, Vue } from 'vue-property-decorator'
import HelloWorld from '@/components/HelloWorld.vue'

import { Api } from '@/service/api'

@Component({
  components: {
    HelloWorld
  }
})
export default class Home extends Vue {

}
